import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import PreviousClassesCalculator from '../PreviousClassesCalculator';

const HorseInformation = ({
  formData,
  handleInputChange,
  validateField,
  commonStyles,
  classes,
  setClasses,
  colors
}) => {
  const onBlur = (fieldName) => {
    if (validateField) {
      validateField(fieldName);
    }
  };

  return (
    <div style={{
      backgroundColor: colors.surface,
      padding: '24px',
      borderRadius: '12px',
      marginBottom: '24px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    }}>
      <h3 style={{
        color: colors.text.primary,
        fontSize: '1.2rem',
        fontWeight: '700',
        marginBottom: '20px',
        paddingBottom: '10px',
        borderBottom: `2px solid ${colors.primary}`
      }}>Horse Information</h3>
      
      <style>
        {`
          .horse-info-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
            margin-bottom: 20px;
          }

          .horse-info-input {
            width: 100%;
            max-width: 300px;
          }

          @media (max-width: 768px) {
            .horse-info-grid {
              grid-template-columns: 1fr;
              gap: 20px;
            }

            .horse-info-input {
              max-width: 100%;
            }

            .input-container {
              max-width: 300px;
            }
          }
        `}
      </style>

      <div className="horse-info-grid">
        <div className="input-container">
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: colors.text.primary,
            fontSize: '1rem',
            fontWeight: '700'
          }}>
            Horse Name *
          </label>
          <input
            type="text"
            name="horseName"
            value={formData?.horseName || ''}
            onChange={handleInputChange}
            onBlur={() => onBlur('horseName')}
            required
            placeholder="Enter horse name"
            style={{
              ...commonStyles.input
            }}
            className="horse-info-input"
          />
        </div>

        <div className="input-container">
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: colors.text.primary,
            fontSize: '1rem',
            fontWeight: '700'
          }}>
            Rider Name
          </label>
          <input
            type="text"
            name="riderName"
            value={formData?.riderName || ''}
            onChange={handleInputChange}
            placeholder="Enter rider name"
            style={{
              ...commonStyles.input
            }}
            className="horse-info-input"
          />
        </div>

        <div className="input-container">
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: colors.text.primary,
            fontSize: '1rem',
            fontWeight: '700'
          }}>
            Class Name
          </label>
          <input
            type="text"
            name="className"
            value={formData?.className || ''}
            onChange={handleInputChange}
            placeholder="Enter class name"
            style={{
              ...commonStyles.input
            }}
            className="horse-info-input"
          />
        </div>

        <div className="input-container">
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: colors.text.primary,
            fontSize: '1rem',
            fontWeight: '700'
          }}>
            Draw Number *
          </label>
          <input
            type="number"
            name="draw"
            value={formData?.draw || ''}
            onChange={handleInputChange}
            onBlur={() => onBlur('draw')}
            min="1"
            required
            placeholder="Enter draw number"
            style={{
              ...commonStyles.input
            }}
            className="horse-info-input"
          />
        </div>

        <div className="input-container">
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: colors.text.primary,
            fontSize: '1rem',
            fontWeight: '700'
          }}>
            Total Class Entries
            <div style={{ position: 'relative', display: 'inline-block', marginLeft: '4px' }}>
              <FaInfoCircle 
                style={{ color: colors.primary, cursor: 'help' }}
                title="Enter the total entries in this class. This is a mandatory field, when the 'Reverse Order' is checked"
              />
            </div>
          </label>
          <input
            type="number"
            name="totalRuns"
            value={formData?.totalRuns || ''}
            onChange={handleInputChange}
            min="1"
            required={formData?.isReverseOrder}
            placeholder="Enter total class entries"
            style={{
              ...commonStyles.input
            }}
            className="horse-info-input"
          />
        </div>

        <div className="input-container" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="checkbox"
            name="isReverseOrder"
            checked={formData?.isReverseOrder || false}
            onChange={handleInputChange}
            style={{ width: '20px', height: '20px' }}
          />
          <label style={{ 
            fontSize: '1rem',
            color: colors.text.primary
          }}>
            Reverse Order
            <div style={{ position: 'relative', display: 'inline-block', marginLeft: '4px' }}>
              <FaInfoCircle 
                style={{ color: colors.primary, cursor: 'help' }}
                title="Check this if the class runs in reverse order"
              />
            </div>
          </label>
        </div>
      </div>

      <PreviousClassesCalculator
        classes={classes}
        setClasses={setClasses}
        formData={formData}
        colors={colors}
        commonStyles={commonStyles}
      />
    </div>
  );
};

export default HorseInformation; 